import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' },
    codigoExterno: { label: i18n.t('clients.cod_ext'), value: '' },
    ns: { label: i18n.t('app.serial_number'), value: '' },
    partner: { label: i18n.t('clients.partner'), value: '' },
    grupoCliente: { label: i18n.t('clients.grupo_cliente'), value: '', labelValue: '' },
    tipoServicio: { label: i18n.t('clients.service_type'), value: '' },
    activo: { label: i18n.t('app.active'), value: '' }, 
  }
}
const getColumns =function getColumns () {
  return [
    { field: 'selected', width: '50px', headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
    { field: 'idCliente', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      }, 
    },
    { field: 'Nombre', width: '300px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    {
      field: 'Activo',
      title: i18n.t('app.active'),
      hidden: false,
      columnMenu: 'myTemplate',
      width: '100px',
      locked: false,
      cell: 'checkboxTemplate',
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active') } 
    },
    { field: 'CodigoExterno', width: '300px', title: i18n.t('clients.cod_ext'), columnMenu: 'myTemplate', locked: false },
    { field: 'NumeroSerie', width: '300px', title: i18n.t('app.serial_number'), columnMenu: 'myTemplate', locked: false },
    { field: 'Partner', width: '150px', title: i18n.t('clients.partner'), columnMenu: 'myTemplate', locked: false },
    { field: 'GrupoCliente', width: '240px', title: i18n.t('clients.grupo_cliente'), columnMenu: 'myTemplate', locked: false },
    { field: 'MesesUserPass', width: '390px', title: i18n.t('clients.users_submenu.mesesUserPass'), format: 'MESES_USER_PASS_CADUC', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, hidden: true, extraparams: { ignoreNull: false } },
    { field: 'TipoServicio', width: '150px', title: i18n.t('clients.service_type'), format: 'TIPOS_SERVICIO', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'FechaAlta', width: '200px', title: i18n.t('clients.fecha_alta'), format: 'numeric_datetime', type: 'date', filter: 'date', cell: 'fechaTemplate', columnMenu: 'myTemplate', locked: false, hidden: false, extraparams: { separators: { date: '-', datetime: ' ' } } },
    { field: 'NumFacturas', width: '300px', title: i18n.t('license.num_invoices'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: false },
    // { field: 'NumVolumen', width: '300px', title: i18n.t('license.num_volumen_invoices'), columnMenu: 'myTemplate', locked: false, hidden: false },
    { field: 'NumeroCIFEmpresas', width: '200px', title: i18n.t('license.num_companies'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: true },
    { field: 'NumeroUsuarios', width: '200px', title: i18n.t('license.num_users'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: true },
    { field: 'RequiereOTP', width: '300px', title: i18n.t('clients.users_submenu.otp'), columnMenu: 'myTemplate', locked: false, hidden: true, cell: 'checkboxTemplate' },
    { field: 'CambioPassPrimerAcceso', width: '320px', title: i18n.t('clients.users_submenu.first_access'), columnMenu: 'myTemplate', locked: false, hidden: true, cell: 'checkboxTemplate' },
    { field: 'PagarAlContabilizar', width: '320px', title: i18n.t('clients.factura_submenu.auto_paid'), columnMenu: 'myTemplate', locked: false, hidden: true, cell: 'checkboxTemplate' },
  ] 
}
const mystore = parent({ navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
